module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "options d-flex align-items-center m-3 justify-content-between"
  }, [_c('div', {
    staticClass: "d-flex align-items-center col-sm-6 pl-0"
  }, [_c('div', {
    staticClass: "d-flex w-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "glued-right bg-lighter w-100",
    attrs: {
      "type": "text",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex m-3 align-items-center w-100 ml-3"
  }, [_c('span', {
    staticClass: "fs-small bold mr-2"
  }, [_vm._v("Show inactive products")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "labels": {
        checked: 'Yes',
        unchecked: 'No'
      }
    },
    on: {
      "change": _vm.toggleShowInactive
    },
    model: {
      value: (_vm.showInactive),
      callback: function($$v) {
        _vm.showInactive = $$v
      },
      expression: "showInactive"
    }
  })], 1)]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.addProduct
    }
  }, [_c('i', {
    staticClass: "ico ico-add mt-1"
  }), _vm._v(" Add Product\n            ")])]), _vm._v(" "), (_vm.getLoadingProducts) ? _c('div', {
    staticClass: "p-4 text-center"
  }, [_c('loader')], 1) : _c('div', [_c('list', {
    attrs: {
      "header": _vm.header,
      "body": _vm.body,
      "rows": _vm.filteredResults,
      "actions": _vm.actions
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "glued-left dark"
  }, [_c('i', {
    staticClass: "ico-search larger color-1"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5190b8ed", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5190b8ed"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/Products.vue
// module id = 3032
// module chunks = 0